import { useInfiniteQuery, useQuery } from "react-query";
import {
  getMenuProducts,
  getMenus,
  getSelectedStorefrontProduct,
  getStorefrontDetail,
  getStorefrontProductList,
  getViewMenuDetail,
  getViewMenuList,
} from "../../../services/inventory";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import { menuProductRestructure } from "../../../helpers";

export const useGetStorefrontMenus = (id) => {
  return useQuery(
    ["getStorefrontMenus", id],
    () => getViewMenuList({ id }).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: id ? true : false,
    },
  );
};

export const useGetViewStorefrontDetail = (id) => {
  return useQuery(
    ["getStorefrontDetails", id],
    () => getStorefrontDetail({ id }).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: id ? true : false,
    },
  );
};

export const useGetViewMenuDetail = (id) => {
  return useQuery(
    ["getViewMenuDetail", id],
    () => getViewMenuDetail({ id }).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: id ? true : false,
    },
  );
};

export const useGetSelectedStorefrontProduct = (id) => {
  return useQuery(
    ["getSelectedStorefrontProduct", id],
    () =>
      getSelectedStorefrontProduct({ id }).then((res) => {
        return menuProductRestructure(res?.data?.data);
      }),
    {
      staleTime: Infinity,
      enabled: id ? true : false,
    },
  );
};

export const useGetStorefrontProductList = ({
  queries = "",
  storefrontId,
  params = {},
}) => {
  return useQuery({
    queryKey: ["getProductList", queries, params],
    staleTime: Infinity,
    enabled: storefrontId ? true : false,
    queryFn: () =>
      getStorefrontProductList({
        storefrontId: storefrontId || undefined,
        queries,
        params,
      }).then((res) => {
        return res?.data;
      }),
  });
};

export const useGetStorefrontList = ({ queries = "" }) => {
  return useQuery(
    ["getStorefrontList", queries],
    () => getMenus(queries).then((res) => res.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetProductListForStorefront = ({
  queryParams = {},
  isEnabled = true,
}) => {
  const { ref: autoScrollRef, inView } = useInView();

  const productListQueries = useInfiniteQuery(
    ["getMenuProducts", [queryParams]],
    ({ pageParam = 1 }) =>
      getMenuProducts({
        ...queryParams,
        page: pageParam,
      }).then((res) => {
        return {
          data: menuProductRestructure(res?.data?.data),
          meta: res?.data?.meta,
        };
      }),
    {
      enabled: isEnabled,
      staleTime: Infinity,
      getNextPageParam: ({ meta: { next_page } }) =>
        next_page === null ? undefined : next_page,
    },
  );

  const { data, hasNextPage, fetchNextPage } = productListQueries;
  const products = new Map();
  // eslint-disable-next-line array-callback-return
  data?.pages?.map((page) => {
    products.set(`${page.meta.current_page}`, page?.data);
  });
  const productsItemList = [].concat(...products.values());

  useEffect(() => {
    if (inView && hasNextPage) fetchNextPage();
  }, [inView, fetchNextPage, hasNextPage]);

  return {
    ...productListQueries,
    autoScrollRef,
    data: productsItemList,
  };
};
